// extracted by mini-css-extract-plugin
export default {"primary":"#001f3f","secondary":"#06c","gray":"#888"};